import moment from 'moment';
import { JourneyParams } from 'shared-types/Common';
import { useStaticRooms, useAvailableRooms } from '@features/rooms';
import { toRoomItems } from './mappers';

export default function useRooms(journeyParams: JourneyParams, language?: string) {
  const {
    fromDate: jpFrom,
    toDate: jpTo,
    adults,
    children,
    childAges,
    rooms: jpRooms,
  } = journeyParams;
  const fromDate = moment(jpFrom).format('YYYY-MM-DD');
  const toDate = jpTo
    ? moment(jpTo).format('YYYY-MM-DD')
    : moment(jpFrom).add(1, 'days').format('YYYY-MM-DD');

  const staticRoomsQuery = useStaticRooms(language);
  const availableRoomsQuery = useAvailableRooms({
    fromDate,
    toDate,
    adults,
    children,
    childAges,
    rooms: jpRooms || [{ roomNumber: 1, adults, children }],
  });
  const staticRooms = staticRoomsQuery.data?.data ?? [];
  const availableRooms = availableRoomsQuery.data?.data ?? [];
  const rooms = toRoomItems(staticRooms, availableRooms);

  return {
    rooms,
    isFetching: staticRoomsQuery.isFetching || availableRoomsQuery.isFetching,
    error: staticRoomsQuery.error || availableRoomsQuery.error,
  };
}
